import { SelectableModel } from '@app/component/autocomplete/abstract-autocomplete/selectable-model';

export class Questionnaire extends SelectableModel {
  name!: string;
  surveyUri?: string;
  questionsCount?: number;
}
